// extracted by mini-css-extract-plugin
export default {"Container":"Switch_Container__+m6uB"};